<template>
  <div class="parent-box">
    <head-bar ref="headBar" @mineMenuChange="mineMenuChange"></head-bar>
    <div class="main-body">
      <router-view ref="routerView" @login="login"/>
    </div>
    <foot-bar></foot-bar>
  </div>
</template>

<script>
import headBar from "@/components/head-bar";
import footBar from "@/components/foot-bar";
export default {
  name: "container",
  components:{
    headBar,
    footBar
  },
  data() {
    return {

    }
  },
  watch: {
      '$route' (to, from) {
  		this.checkRoute()
      }
  },
  mounted() {
    this.checkRoute();
  },
  methods: {
    // 当前选择的menu高亮
    checkRoute() {
      let name = this.$route.name;
      switch (name){
        // 首页
        case "home":
          this.$refs.headBar.menuIndex = 0;
          break;
        // 找工作
        case "find-job":
        case "job-detail":
        case "store-detail":
		console.log("################")
          this.$refs.headBar.menuIndex = 1;
          break;
        //  找人才
        // case "find-careers":
        // case "career-detail":
        //   this.$refs.headBar.menuIndex = 2;
        //   break;
        //  培训课程
        case "course-list":
        case "course-detail":
          this.$refs.headBar.menuIndex = 2;
          break;
        //  考试认证
        case "examination":
        case "examination-detail":
        case "online-operation":
        case "online-operation-result":
        case "written-test":
        case "written-test-result":
          this.$refs.headBar.menuIndex = 3;
          break;
        //  关于我们
        case "about-us":
          this.$refs.headBar.menuIndex = 4;
          break;
        default:
          this.$refs.headBar.menuIndex = -1;
          break;
      }
    },
    // 个人中心的下拉菜单切换事件
    mineMenuChange(e){

      if(e!==9){
        this.$refs.routerView.mineMenuChange(e)
      }else{
        // 退出登录时
        // 清除用户信息 返回首页
        this.$router.replace({name:"home"})
      }

    },
    // 登录页登录事件
    login(e){
      console.log(1)
      this.$refs.headBar.isLogin = e;
      this.$router.replace({name: "home"});
    }
  }
}
</script>

<style>
body{
  background: #F6F6F8;
}
</style>

<style lang="scss" scoped>
/*隐藏滚动条*/
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  color: transparent !important;
  display: none!important;
}
  .main-body{
    padding-bottom: 314px;
  }
  .parent-box{
    min-height: 100%;
    height: auto!important;
    height: 100%;
    position: relative;
  }
</style>
